/**
 * Route segments are reused in both route config and UI navigation config.
 */
export const ROUTE_SEGMENTS = {
  dashboard: '',
  licenses: 'licenses',
  devices: 'devices',
  users: 'users',
  logs: 'logs',
  skills: 'skills',
} as const;

/**
 * Full paths for navigation and redirects.
 */
export const APP_ROUTES = {
  home: '/',
  login: '/login',
  licenses: '/licenses',
  devices: '/devices',
  users: '/users',
  logs: '/logs',
  skills: '/skills',
} as const;

export type AppRoutePath = (typeof APP_ROUTES)[keyof typeof APP_ROUTES];

